module.exports = __webpack_public_path__ + "img/fc1.060a0137.png";